import { render, staticRenderFns } from "./OrderFood.vue?vue&type=template&id=e7c70692"
import script from "./OrderFood.vue?vue&type=script&lang=js"
export * from "./OrderFood.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/050/050admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e7c70692')) {
      api.createRecord('e7c70692', component.options)
    } else {
      api.reload('e7c70692', component.options)
    }
    module.hot.accept("./OrderFood.vue?vue&type=template&id=e7c70692", function () {
      api.rerender('e7c70692', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/chart/OrderFood.vue"
export default component.exports